const confirmPrompt = {
  current: async (title?: string, content?: string, textConfirm?: string) =>
    true
}

export const getConfirmPromptRef = (): typeof confirmPrompt => confirmPrompt
